import { useState } from "react";
import { Form, message } from "antd";
import { useNavigate } from "react-router-dom";
import { ValidateForm } from "../../utils/validateForm";

import api from "../../services/api";

const STAGES: Record<string, string> = {
  USERNAME: "USERNAME",
  PASSWORD: "PASSWORD",
};

const INSTRUCTIONS: {
  [key: string]: string;
} = {
  USERNAME: "Por favor ingresa tu correo electrónico",
  PASSWORD:
    "Por favor ingresa el código que te enviamos a tu correo electrónico y tu nueva contraseña",
};

export const useRecoverPassword = () => {
  const [loading, setLoading] = useState(false);
  const [stage, setStage] = useState<keyof typeof STAGES>(STAGES.USERNAME);
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const [username, setUsername] = useState("");

  const handleForgotPassword = async () => {
    try {
      setLoading(true);
      const validForm = await ValidateForm(form);
      if (!validForm) {
        setLoading(false);
        return;
      }
      const data = form.getFieldsValue();
      console.log("data", data);
      const { username } = data;
      setUsername(username);
      
      await api.post("/auth/recover-password", { email: username });
      message.success("Si el correo existe, enviamos un código de recuperación");
      setStage(STAGES.PASSWORD);
    } catch (error: any) {
      console.log("error", error);
      message.error(error.response?.data?.message || "Error al solicitar el cambio de contraseña");
      setStage(STAGES.USERNAME);
    } finally {
      setLoading(false);
    }
  };


  const handleResetPassword = async () => {
    try {
      setLoading(true);
      const validForm = await ValidateForm(form);
      if (!validForm) {
        setLoading(false);
        return;
      }
      const data = form.getFieldsValue();
      const { code, password } = data;
      
      await api.post("/auth/reset-password", {
        email: username,
        code,
        password,
      });
      
      message.success("Contraseña cambiada con éxito");
      navigate("/login");
    } catch (error: any) {
      message.error(error.response?.data?.message || "Error al cambiar la contraseña. Verifica el código y vuelve a intentar.");
    } finally {
      setLoading(false);
    }
  };

  return {
    form,
    handleForgotPassword,
    handleResetPassword,
    stage,
    loading,
    instructions: INSTRUCTIONS[stage],
  };
};
